module.exports = __webpack_public_path__ + "img/desktop.eeff02ee.png";